import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import seoConfig from '../config/seoConfig';

const SEOManager = () => {
  const location = useLocation();

  const seo = seoConfig[location.pathname] || {
    title: 'DAAT Global | African Design, Art, Architecture & Technology',
    description: 'A dynamic intersection of Design, Art, Architecture and Technology rooted in the timeless expression of Africa\'s rich cultural heritage.',
    canonical: `https://daatglobal.com${location.pathname}`,
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.canonical} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.canonical} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
    </Helmet>
  );
};

export default SEOManager;